import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IMessage } from "../types/message";

// Define the initial state using that type
const initialState: IMessage = {
  message: null,
  type: "",
  title: "",
  status: "",
};

export const message = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<IMessage>) => {
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.title = action.payload.title;
      state.status = action.payload.status;
    },
    clearMessage: (state) => {
      state.message = "";
      state.type = "";
      state.title = "";
      state.status = "";
    },
  },
});

export const { setMessage, clearMessage } = message.actions;

export default message.reducer;
